import { Topbar } from '@/components/organisms/Topbar';
import { Skeleton } from '@/components/ui/skeleton';
import { DataTableLoadingRows } from '@/components/organisms/DataTableLoadingRows';

// Mirrors `AuditLogsPage`'s real column set (module/action/actor/entity/when)
// and its two fixed-width columns.
const COLUMNS = 5;
const GRID_TEMPLATE = '130px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) 170px';

/**
 * `/audit-logs` route pending state: Topbar (with a Filters-button-shaped
 * skeleton in the actions slot, matching where the real `filtersBar` lives)
 * + the existing `DataTableLoadingRows` organism for the table body — reused,
 * not reinvented.
 */
export function AuditLogsPendingState() {
  return (
    <>
      <Topbar
        crumbs={[{ label: 'Organization' }, { label: 'Audit Logs' }]}
        title="Audit Logs"
        actions={<Skeleton className="h-8 w-20 rounded-md" />}
      />

      <div
        className="flex min-h-0 flex-1 flex-col overflow-auto"
        style={{ background: 'var(--canvas)' }}
      >
        <div
          className="flex w-full flex-col gap-4 px-4 py-6 md:px-8"
          aria-busy="true"
          aria-live="polite"
        >
          <div
            role="table"
            aria-label="Audit logs"
            className="rounded-[var(--r-md)] border"
            style={{ borderColor: 'var(--ink-100)', background: 'var(--paper)' }}
          >
            {/* `announce={false}` — the outer wrapper above already owns the
                `aria-live`/`aria-busy` announcement for this page-level
                loading state; a second, differently-labelled live region
                here would double-announce the same event. */}
            <DataTableLoadingRows
              rows={8}
              columns={COLUMNS}
              gridTemplate={GRID_TEMPLATE}
              announce={false}
            />
          </div>
        </div>
      </div>
    </>
  );
}
